import type { UflrType } from 'lib/uflr';
import type { DomainAccess } from 'reactApp/components/SharingWindow/Sharing.types';
import type { IAlbum } from 'reactApp/modules/albums/albums.types';
import type { ApiFolderResponse, IFolderFlags } from 'reactApp/modules/home/home.types';
import type { WeblinkDownloadable } from 'reactApp/modules/public/public.types';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';
import type { AccessRights, IPublicInfo, Kind, SubKind, Url, VirusScan } from 'reactApp/types/Tree';

export enum FamilyContentCategoryType {
    folders = 'folders',
    albums = 'albums',
}

export interface FamilyContentCategory {
    name: string;
    id: FamilyContentCategoryType;
    value: FamilyContentCategoryType;
    childs: string[];
    isLoaded: boolean;
    isLoading: boolean;
}

export interface FamilyContentState {
    categories: FamilyContentCategory[];
    currentCategory: FamilyContentCategoryType;
    list: any;
}

export interface ChangeFamilyContentCategoryAction {
    category: FamilyContentCategoryType;
}

export interface FamilyContentLoadRequestAction {
    category: FamilyContentCategoryType;
}

export interface FamilyFoldersLoadSuccessAction {
    category: FamilyContentCategoryType;

    // TODO: Добавить тип данных для семейных папок [CLOUD-4573]
    data: ApiFolderResponse;
}

export interface FamilyAlbumsLoadSuccessAction {
    category: FamilyContentCategoryType;

    // TODO: Добавить тип данных для семейных альбомов [CLOUD-4573]
    data: {
        id: string;
        list: IAlbum[];
    };
}

export interface FamilyContentUpdateFolderListAction {
    id: string;
}

export interface FamilyContentFolderItemBase extends WeblinkDownloadable {
    id: string;
    isFolder: boolean;
    isInFavorites: boolean;
    parent: string;
    ext: string;
    nameWithoutExt: string;
    name: string;
    home: string;
    size: number;
    kind: Kind;
    subKind: SubKind;
    url: Url;
    weblink?: string;
    weblinkAccessRights?: AccessRights;
    weblinkAutoDelete?: boolean;
    weblinkSeoEnabled?: boolean;
    weblinkEnabledDisabledDownload?: boolean;
    weblinkExpires?: number;
    ctime?: number;
    expiresTimeSize?: number;
    weblinkDomestic?: boolean;
    weblinkDomainAccess?: DomainAccess;
    mtime: number;
    hash: string;
    __reduxTree?: boolean;
    thumbnails?: {
        [key: string]: string;
    };
    virusScan: VirusScan;
    isReadOnly: boolean;
    uflr?: UflrType;
    intraDomainShare?: boolean;
}

export interface FamilyContentAlbum extends Partial<IPublicInfo>, WeblinkDownloadable {
    id: string;
    name: string;
    storage: EStorageType.albums;
    isFolder: true;
    kind: Kind;
    cursor?: string;
    isLoading?: boolean;
    isLoaded?: boolean;
    hasMoreToLoad?: boolean;
    parent: string;
    flags?: IFolderFlags;
    type: 'album';
    childs: string[];
    photosCount?: number;

    thumbnails?: Record<string, string>;

    error?: boolean;
    isReadOnly?: boolean;
    home?: string;
    ctime?: number;
    expiresTimeSize?: number;
    intraDomainShare?: boolean;
    href?: string;
    isOpenBlank?: boolean;
}
